import { Collapse } from 'bootstrap'
import slideout from 'slideout'
import { tns } from 'tiny-slider/src/tiny-slider'
import { Fancybox } from '@fancyapps/ui'
  import '@fancyapps/ui/dist/fancybox/fancybox.css'

/**
 * Fancybox.
 */
Fancybox.bind()

// WooCommerce product image gallery.
Fancybox.bind('.woocommerce-product-gallery__wrapper a', {
  groupAll: true,
})

/**
 * Slideshow.
 * Currently just used in the testimonials block.
 * 
 * @see https://github.com/ganlanyuan/tiny-slider
 */
if (document.querySelector('.slideshow .slides')) {
  const slider = tns({
    container: '.slideshow .slides',
    items: 1,
    slideBy: 'page',
    autoplay: true,
    autoplayButtonOutput: false,
    controls: true,
    controlsPosition: 'bottom',
    controlsText: ["", ""],
    nav: false,
  })
}

/**
 * Condense header on scroll.
 */
window.addEventListener('scroll', () => {
  const scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  const body = document.querySelector('body')
  
  if (scrollTop > document.querySelector('.app-header').clientHeight) {
    body.classList.add('header-condensed')
  } else {
    body.classList.remove('header-condensed')
  }
})

/**
 * Scroll to element.
 */
const scrollToElements = document.querySelectorAll('[data-scroll-to]')
for (const scrollToElement of scrollToElements) {
  scrollToElement.addEventListener('click', e => {
    e.preventDefault()

    const selector = e.target.dataset.scrollTo
    const offsetTop = document.querySelector(selector).offsetTop

    scroll({
      top: offsetTop,
      behavior: 'smooth',
    })
  })
}

/**
 * Slideout Nav.
 * @see https://github.com/mango/slideout
 */
const slideoutNav = new slideout({
  panel: document.getElementById('app-panel'),
  menu: document.getElementById('app-nav-mobile'),
  padding: 320,
  tolerance: 70,
  side: 'right',
  touch: false,
})

document.querySelector('.nav-icon').addEventListener('click', () => {
  slideoutNav.toggle()
})

document.querySelector('#app-nav-mobile .btn-close').addEventListener('click', () => {
  slideoutNav.close()
})

// Sub-menus
document.querySelectorAll('#app-nav-mobile .nav-link').forEach(link => {
  link.addEventListener('click', (e) => {
    if (e.target.getAttribute('href') == '#') {
      var btn = e.target.nextElementSibling
      var myCollapse = document.querySelector(btn.getAttribute('data-bs-target'))
      var bsCollapse = new Collapse(myCollapse, {
        toggle: true,
      })
    }
  })
})

/**
 * Modals.
 *
 * Appends the Bootstrap modal backdrop to the app panel
 * so that it is under the modal itself.
 */
const modals = document.querySelectorAll('.modal')
modals.forEach(modal => {
  modal.addEventListener('show.bs.modal', e => {
    const backdrop = document.createElement('div')
    backdrop.classList.add('modal-backdrop', 'fade', 'show')
    document.querySelector('#app-panel').appendChild(backdrop)
  })

  modal.addEventListener('hidden.bs.modal', e => {
    const backdrop = document.querySelector('.modal-backdrop')
    backdrop.parentNode.removeChild(backdrop)
  })
})
